// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"Breadcrumbs_Breadcrumbs__K6nTC","link":"Breadcrumbs_link___lxAf","icon":"Breadcrumbs_icon__OXHBX"};